var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-fa of",staticStyle:{"padding":"40px"}},[_c('el-alert',{attrs:{"title":"支付成功！","type":"success"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }